<template>
    <div class="signup-client__side-content">
        <VJoyWrapper no-margin>
            <VJoyTitleBrand>
                <p class="signup-client__side-content__title" v-html="content.title" />
            </VJoyTitleBrand>
            <MaltImg width="319" :src="content.imageUrl" class="signup-client__side-content__img" alt="" />
        </VJoyWrapper>
        <div class="signup-client__side-content__benefits">
            <div v-for="(benefit, index) in content.body" :key="`benefit-${index}`">
                <div class="signup-client__side-content__benefits-item">
                    <VJoyIcon v-if="content.body.length > 1" name="check-circle" color="white" />
                    <p v-html="benefit" />
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import {MaltImg} from '#components';
    import {VJoyTitleBrand, VJoyWrapper, VJoyIcon} from '@maltjoy/core-vue';
    import {type SideContent} from './SideContentLoader.vue';

    defineProps<{content: SideContent}>();

    /**
     * TODO:
     * - For now (v1): use current page or step to define the side content to display
     * - create one component for the content of each step to be able to create async component
     * - Add animation during loading / changing
     */
</script>

<style lang="scss">
    .signup-client__side-content {
        text-align: left;

        .joy-title-brand {
            span {
                margin: 0px;
                display: inline-block;
            }
        }

        .joy-wrapper {
            gap: var(--joy-core-spacing-9);
        }

        &__title {
            font-size: var(--joy-font-size-secondary-400);
        }

        &__benefits {
            margin-top: var(--joy-core-spacing-9);
            font-size: var(--joy-font-size-primary-600);
            letter-spacing: -0.4px;

            &-item {
                margin-bottom: var(--joy-core-spacing-2);
                display: flex;
                align-items: center;
                gap: var(--joy-core-spacing-2);
            }
        }

        &__img {
            object-fit: contain;
            max-height: 288px;
            max-width: 319px;
        }
    }
</style>
